var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPayments = function SvgPayments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#payments_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.74 4h13.334a.741.741 0 0 1 .74.74v10.167a.74.74 0 0 1-.74.741H3.741a.74.74 0 0 1-.741-.74V4.74A.74.74 0 0 1 3.74 4Zm12.593 4.24H4.482v5.927h11.851V8.24Zm0-1.48V5.48H4.481V6.76h11.852Zm-4.444 4.444h2.963v1.481h-2.963v-1.481Z",
    fill: "#1D1737"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "payments_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgPayments;